module.exports = __webpack_public_path__ + "img/message-circle-seven.e2e805b8.svg";